var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-description",class:{
    'h5-course-description': _vm.isH5,
    'pc-course-description': !_vm.isH5,
    'electron-course-description': _vm.isElectron,
  }},[_c('div',[_c('div',{staticClass:"ql-editor",class:{
        'product-info-wrap': _vm.canShowAllInfo,
        'show-all': _vm.showAllStatus,
      },domProps:{"innerHTML":_vm._s(_vm.courseDescription)}})]),(_vm.canShowAllInfo)?_c('div',{staticClass:"show-all-info"},[(!_vm.showAllStatus)?_c('span',{on:{"click":function($event){_vm.showAllStatus = true}}},[_vm._v(" 展开"),_c('i',{staticClass:"el-icon-arrow-down"})]):_c('span',{on:{"click":function($event){_vm.showAllStatus = false}}},[_vm._v(" 收起"),_c('i',{staticClass:"el-icon-arrow-up"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }